import React from "react";
import { connect } from "react-redux";
import { TTP_LOGO_URL } from "../../config/Common";
import Community from "./Community";
import { setCurrentClient } from 'thunks';
import { browserHistory } from "react-router";

const SelectCommunity = ({ auth, dispatch }) => {

  const handleSelectOrganization = (client) => {
    dispatch(setCurrentClient(client));
    // const uri = getEmailingRedirectStorage();
    // if (uri) {
    //   browserHistory.push(uri);
    // }
    // setEmailingRedirectStorage(null);
  };

  const renderOrganizations = () => {
    const { user } = auth;
    if (!user) {
      return null;
    }

    return user.paymentClients.map(client => (
      <Community
        key={client.id}
        community={client}
        onClick={() => handleSelectOrganization(client)}
      />
    ));
  };

  return (
    <div id="select-community">
      <div className="sc__container">
        <span className="sc__logo">
          <img src={TTP_LOGO_URL} alt="logo" />
        </span>
        <div className="sc__communities grid-x grid-margin-x">
          {renderOrganizations()}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  auth: store.auth,
});

export default connect(mapStateToProps)(SelectCommunity);


// WEBPACK FOOTER //
// ./app/components/SelectCommunity/SelectCommunity.js